import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { finalize, Observable } from 'rxjs';

import { OnboardingState } from '@shared/models';

import { BaseService } from '../base.service';
import { LoadersService } from '../loaders.service';

@Injectable({
  providedIn: 'root',
})
export class OnboardingService extends BaseService {
  constructor(
    private http: HttpClient,
    private loadersService: LoadersService
  ) {
    super();
  }

  getCompanyOnboardingState(id: string, loader: string): Observable<OnboardingState> {
    this.loadersService.show(loader);
    return this.http
      .get<OnboardingState>(`${this.baseUrl}/onboarding/company/${id}`)
      .pipe(finalize(() => this.loadersService.hide(loader)));
  }

  getProjectOnboardingState(id: string, loader: string): Observable<OnboardingState> {
    this.loadersService.show(loader);
    return this.http
      .get<OnboardingState>(`${this.baseUrl}/onboarding/project/${id}`)
      .pipe(finalize(() => this.loadersService.hide(loader)));
  }
}
